import { clsx } from 'clsx'
import { RoundButton } from 'component/Button/RoundButton'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { session } from 'feature/widget/SessionStore'
import { try_on } from 'feature/widget/TryOnStore'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { BasicLogo } from 'page/catalog/BasicLogo/BasicLogo'
import { demo } from 'page/catalog/store/CatalogStore'
import { standExit, StandExitModalStore } from 'page/catalog/store/StandExitModalStore'
import { ui } from 'store/home/ui/HomeUiStore'
import { opt } from 'store/opt'
import css from './BasicUserPane.module.scss'

export const BasicUserPane = observer(() => {
  const { mobile } = ui.window
  const { picture } = demo.it.widget

  const onExit = useLatestCallback(async () => {
    if (picture) {
      try_on.close()
      standExit.open(new StandExitModalStore())
    } else {
      session.stop()
    }
  })

  return <Space className={clsx(css.pane, opt.sochi && css.sochi)} wrap opposite>
    <Space className={css.logo} gap={12} wrap tall pad={[0, 16]} round={16} center>
      <BasicLogo bottom />
    </Space>
    <Space tall>
      <RoundButton pad={mobile ? [0, 24] : [0, 32]} height="100%" danger onClick={onExit}>
        <Typo size={19}>
          {i18n('EndSession')}
        </Typo>
      </RoundButton>
    </Space>
  </Space>
})
